// extracted by mini-css-extract-plugin
export default {"markdownBlock":"SummaryInfoBlock_markdownBlock__Ds0N+","markdownChatAIBlock":"SummaryInfoBlock_markdownChatAIBlock__px7b1"};